import './action-cell.scss';
import React from 'react';
import { observer } from 'mobx-react-lite';
import CustomIcon, { IconType } from '../custom-icon/custom-icon';
import { toCamelCase } from '../../../utils/string-normalization';
import { ActionType } from '../../../utils/enums';
import { ActionOption } from '../../../dtos/version.dto';

interface ProfileCellProps {
    action: ActionOption;
}

export const ActionCell: React.FC<ProfileCellProps> = observer(({action}) => {

    return <div className={'action-cell-content'}>
        <CustomIcon className={action} type={toCamelCase(action) === ActionType.ALLOW ? IconType.ALLOW_ICON : IconType.BLOCK_ICON} />
        <div className={`action ${action}`}>{action}</div>
    </div>;
});